module.exports = __webpack_public_path__ + "bfad9a78d639613a341eef6c742a84d9.png";